import React, { useEffect, useState } from 'react';
import ClientServiceSection from '../clientService/ClientServiceSection';
import { Form } from 'react-final-form';
import DwFormField from '@common/ui/formfield/DwFormField';
import Button from '@stone/ui/button/Button';
import ErrorBox from '@components/common/ErrorBox';
import formutils from '@utils/formutils';
import createDecorator from 'final-form-focus';
import api from '@common/utils/api';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
// import analytics from '@common/utils/analytics';
import { useSelector } from 'react-redux';
import { isUserAuthenticated } from '@common/state/features/orders.selectors';
import { addURLParameter, addURLParameters } from '@common/utils/urlutils';
const focusOnError = createDecorator();
const TrackingOrderForm = (props) => {
    const { t } = useTranslation();
    const [errors, setErrors] = React.useState([]);
    const [formdef, setFormdef] = useState();
    const [initialValues, setInitialValues] = useState();
    const [id, setId] = useState();
    const [token, setToken] = useState();
    const [aftercareCode, setAftercareCode] = useState();
    const { user: { isAuthenticated }, } = useSelector(isUserAuthenticated);
    const goToOrderDetail = (order) => {
        window.location.href = addURLParameters(props.orderdetailurl, { orderId: order.orderNumber, token: order.token });
    };
    const goToReturnDetail = (returncase, token) => {
        window.location.href = addURLParameters(props.returndetailurl, { orderId: returncase, token: token });
    };
    const goToAftercareDetail = (aftercarecase) => {
        window.location.href = addURLParameter(props.aftercareurl, 'orderId', aftercarecase);
    };
    useEffect(() => {
        let val = {};
        api.getForm('tracking', val).then((data) => {
            setInitialValues({}); // we don't want prefill here - https://jira.industries-group.com/browse/ONE-22318
            setFormdef(data);
        });
    }, [id]);
    useEffect(() => {
        if (aftercareCode) {
            goToAftercareDetail(aftercareCode);
        }
        else if (id && (token || isAuthenticated)) {
            if (id.toLowerCase().indexOf('-r') > -1) {
                api.getReturnDetail(id, token).then((order) => {
                    goToReturnDetail(id, token);
                    // analytics.tracking('proceed');
                });
            }
            else {
                api.getOrderDetail(id, token).then((order) => {
                    // analytics.tracking('proceed');
                    if (order) {
                        goToOrderDetail(order);
                    }
                });
            }
        }
    }, [id, token, aftercareCode]);
    const validate = async (values) => {
        return await formutils.validateForm(values, formdef, 'tracking');
    };
    const onSubmit = async (values) => {
        setErrors([]);
        let err = await validate(values);
        if (err && Object.keys(err).length > 0) {
            return err;
        }
        api.trackOrderOrReturn(values, formdef).then((data) => {
            let errors = {};
            if (!formutils.checkValidationAfterSubmit(data, errors)) {
                return errors;
            }
            if (data.errorMessage) {
                setErrors([data.errorMessage]);
                return;
            }
            if (data.id == id) {
                setId(null); // force update in component if the order number was already set
            }
            if (data.type == 'aftercare') {
                setAftercareCode(data === null || data === void 0 ? void 0 : data.id);
            }
            setId(data.id);
            setToken(data.token);
        });
    };
    if (!formdef) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(ClientServiceSection, { title: props.anotherone ? t('tracking.trackanotheritem') : t('tracking.entertrackingnumber'), introSection: !!props.introSection },
            React.createElement(React.Fragment, null,
                React.createElement("p", { className: "mb-60", dangerouslySetInnerHTML: { __html: t('tracking.insertrackingnumber') } }),
                React.createElement(Form, { initialValues: initialValues, onSubmit: onSubmit, decorators: [focusOnError], validate: (values) => validate(values), render: ({ handleSubmit, form, submitting, pristine, values }) => {
                        //save form object to external variable
                        return (React.createElement("form", { onSubmit: handleSubmit, className: "d-column gap-40" },
                            React.createElement(DwFormField, { def: formdef, name: "trackOrderNumber", autocomplete: "orderNumber", value: id, placeholder: t('tracking.form.tracknumber.placeholder') }),
                            React.createElement(DwFormField, { def: formdef, name: "trackOrderEmail", autocomplete: "email", placeholder: t('tracking.form.email.placeholder') }),
                            React.createElement("div", { className: "row row-gap-12" },
                                !window.loggedin && (React.createElement("div", { className: "col-24 col-lg-12" },
                                    React.createElement("a", { href: window.loginUrl, className: "button button--secondary full" },
                                        React.createElement("span", null, t('button.login'))))),
                                React.createElement("div", { className: classNames('col-24 col-lg-12', { 'offset-lg-12': window.loggedin }) },
                                    React.createElement(Button, { disabled: submitting, type: "submit", fullWidth: true },
                                        React.createElement("span", null, t('button.proceed'))))),
                            React.createElement(ErrorBox, { errors: errors, className: "mt-20" })));
                    } })))));
};
export default TrackingOrderForm;
